import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  TOKEN_VERIFY,
  TOKEN_VERIFY_SUCCESS,
  TOKEN_VERIFY_FAIL
} from '../constants/ActionTypes';

const initialState = {
  isAuthenticated: false,
  authenticating: true,
  status: 'notLoggedIn',
  userID: null,
  errors: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        loading: true,
        status: 'loggingIn',
        loggedOut: false
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        data: {},
        isAuthenticated: true,
        authenticating: false,
        loading: false,
        status: 'loggedIn',
        errors: initialState.errors
      };
    case LOGIN_FAIL:
      return {
        ...state,
        data: {},
        isAuthenticated: false,
        authenticating: false,
        loading: false,
        status: 'loginFailed',
        ...action.payload
      };
    case LOGOUT:
        return {
          ...initialState,
          loggedOut: true,
          status: 'loggedOut',
        };
    case TOKEN_VERIFY:
      return {
        ...state,
        authenticating: true
      };
    case TOKEN_VERIFY_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        authenticating: false,
        ...action.payload
      };
    case TOKEN_VERIFY_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        authenticating: false
      };
    default:
      return state;
  }
}
